import script from "./mobileDateStore2.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileDateStore2.vue?vue&type=script&setup=true&lang=js"

import "./mobileDateStore2.vue?vue&type=style&index=0&id=ed4113ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed4113ca"]])

export default __exports__